<template>
  <div class="px-4 pb-10">
    <upload
      :params="{
        idReservation: reservation.idReservation
      }"
      class="mb-12"
      @update="handleUpdate"
    />

    <!--<div v-if="pager.items && pager.items.length" class="flex justify-between items-center space-x-8 mb-8 border-b pb-4">
      <div>
        <h4 class="text-lg mr-4 font-semibold text-gray-700">
          {{ $t('asset.attachedFiles') }}
        </h4>
        <p class="text-sm mr-4 text-gray-600">
          Documents and photos relating to this appointment
        </p>
      </div>
    </div>-->

    <upload-pager :pager="pager" />
  </div>
</template>

<script setup lang="ts">
import Upload from '@/components/upload/elements/Upload.vue'
import UploadPager from '@/components/upload/elements/Pager.vue'

import { EndlessListPager } from '@/_api/lib/pager'

const { $api } = useNuxtApp()

interface Props {
  reservation?: Record<string, any> | null
}

const props = withDefaults(defineProps<Props>(), {
  reservation: null,
})

const emit = defineEmits<{
  (e: 'update:count', value: number): void
}>()

const pager = ref(new EndlessListPager((page: number) => $api.reservation.uploads(String(props.reservation!.idReservation), { page }), 20))

watch(() => pager.value.total, (total) => {
  emit('update:count', total ?? 0)
}, { immediate: true })

function handleUpdate () {
  if (!pager.value.loading) {
    pager.value.reload()
  }
}
</script>
